module.exports = __webpack_public_path__ + "media/images/fdic-5ec7d9e0.png";